import { 
  Card,
  Col,
  Form,
  Input,
  Row,
  Typography,
  List, 
  Select,
  Grid,
} from "antd";
import "../../product-component/productComponent.scss";
import React, { useState } from "react";
import { BankOutlined} from "@ant-design/icons";
import imgv1 from "assets/images/v1.svg";
import imgv2 from "assets/images/v2.svg";
import imgv3 from "assets/images/v3.svg";
import imgv4 from "assets/images/v4.svg"; 
import { SizeType } from "antd/es/config-provider/SizeContext";
import TextArea from "antd/es/input/TextArea";
import CheckoutRightPenalComponent from "../right-penal-component/rightPenalComponent";

function AddToCartComponent() {
  const [form] = Form.useForm(); 

  const [componentSize, setComponentSize] = useState<SizeType | "default">(
    "default"
  );
  const variant = Form.useWatch("variant", form);
  const screens = Grid.useBreakpoint();
  return (
    <>
      <div>
        <Row gutter={[16, 16]} className="mt-5">
          <Col xs={24} sm={24} md={16} lg={16}>
            <Card
              className="annulment-card border-radius-20 p-4"
              bordered
            >
              <Form
                layout="vertical"
                initialValues={{ variant: "filled", size: componentSize }}
                variant={variant || "filled"}
                form={form}
                size={"large"}
                className=""
              >
                <Typography.Title level={4} className={ `mt-0 d-block w-100 ${screens.lg ? 'mb-4 ' : 'mb-0'}`}>
                  <BankOutlined
                  className="danger-color"
                  /> Lead Passenger Details
                </Typography.Title>

                <Row gutter={[16, 16]}>
                  <Col xs={24} lg={4}>
                    <Form.Item name={"mr"} label="&nbsp;" className="mb-0">
                      <Select defaultValue={"Mr."}>
                        <Select.Option value="Mr.">Mr.</Select.Option>
                        <Select.Option value="Mrs.">Mrs.</Select.Option>
                        <Select.Option value="Ms.">Ms.</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={10}>
                    <Form.Item name={"fname"} label="First Name" className="mb-0">
                      <Input placeholder="First Name" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={10}>
                    <Form.Item name={"lname"} label="Last Name" className="mb-0">
                      <Input placeholder="Last Name" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={12}>
                    <Form.Item name={"email"} label="Email" className="mb-0">
                      <Input placeholder="First Name" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item name={"country"} label="Country" className="mb-0">
                      <Select>
                        <Select.Option value="demo">Demo</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={4}>
                    <Form.Item name={"isdcode"} label="ISD Code" className="mb-0">
                      <Select>
                        <Select.Option value="AF (+93)">AF (+93)</Select.Option>
                        <Select.Option value="AL (+355)">
                          AF (+93)
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={8}>
                    <Form.Item name={"phonenumber"} label="Phone Number" className="mb-0">
                      <Input placeholder="" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item name={"agentNumber"} label="Agent Number" className="mb-0">
                      <Select>
                        <Select.Option value="demo">Demo</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <Form.Item name={"country"} label="Special Request" className="mb-0">
                      <TextArea rows={4} />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>

            <Card
              className="annulment-card border-radius-20 p-4 mt-4"
              bordered
            >
              <Form
                layout="vertical"
                initialValues={{ variant: "filled", size: componentSize }}
                variant={variant || "filled"}
                form={form}
                size={"large"}
                className=""
              >
                <Typography.Title level={4} className="mb-4 mt-0 d-block w-100">
                  <BankOutlined    className="danger-color" /> Extra Details
                </Typography.Title>

                <Typography.Title level={5} className="mb-2 mt-0 d-block w-100">
                  Ferrari World Entry Ticket -Dated{" "}
                  <small>-Sharing Transfers</small>
                </Typography.Title>

                <Row gutter={[16, 16]}>
                  <Col xs={24} lg={12}>
                    <Form.Item name={"mr"} label="Pickup Location" className="mb-0">
                      <Input placeholder="Pickup Location" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item name={"fname"} label="First Name" className="mb-0">
                      <Input placeholder="Remark" />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>

            <Card
              className="annulment-card border-radius-20 p-4 mt-4"
              bordered
            >
              <Form
                layout="vertical"
                initialValues={{ variant: "filled", size: componentSize }}
                variant={variant || "filled"}
                form={form}
                size={"large"}
                className=""
              >
                <Typography.Title level={4} className="mb-4 mt-0 d-block w-100">
                  <BankOutlined className="danger-color" /> Choose a Payment Method
                </Typography.Title>

                <Typography.Title level={5} className="mb-2 mt-0 d-block w-100">
                  Ferrari World Entry Ticket -Dated{" "}
                  <small>-Sharing Transfers</small>
                </Typography.Title>

                <Row gutter={[16, 16]}>
                <Col xs={24} lg={12}>
                    <Form.Item name={"mr"} label="Pickup Location" className="mb-0">
                      <Input placeholder="Pickup Location" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item name={"fname"} label="First Name" className="mb-0">
                      <Input placeholder="Remark" />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>

          <Col xs={24} sm={24} md={8} lg={8}>
            {/* <Card className="annulment-card border-radius-20  p-4" bordered>
              <List itemLayout="horizontal" className="list-view-register">
                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv1} />}
                    title={
                      <Typography.Text>
                        {"Dubai Aquarium and Underwater Zoo"}
                      </Typography.Text>
                    }
                  />
                </List.Item>
                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv4} />}
                    title={
                      <Typography.Text>
                        {"Build your Own Package"}
                      </Typography.Text>
                    }
                  />
                </List.Item>
                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv3} />}
                    title={
                      <Typography.Text>
                        {"Online settlement of Invoice & Receipts"}
                      </Typography.Text>
                    }
                  />
                </List.Item>
                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv2} />}
                    title={
                      <Typography.Text>
                        {"Create your Sub Agents"}
                      </Typography.Text>
                    }
                  />
                </List.Item>

                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv2} />}
                    title={
                      <Typography.Text>
                        {"Strong Mark-up module"}
                      </Typography.Text>
                    }
                  />
                </List.Item>

                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv2} />}
                    title={
                      <Typography.Text>
                        {"Live Inventory of products"}
                      </Typography.Text>
                    }
                  />
                </List.Item>

                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv2} />}
                    title={
                      <Typography.Text>
                        {"Add to Favorite list"}
                      </Typography.Text>
                    }
                  />
                </List.Item>

                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv2} />}
                    title={
                      <Typography.Text>
                        {
                          "Multiple Tour options, Transfer options & time slots for the same tour"
                        }
                      </Typography.Text>
                    }
                  />
                </List.Item>
                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv2} />}
                    title={
                      <Typography.Text>
                        {"Shopping Cart application"}
                      </Typography.Text>
                    }
                  />
                </List.Item>
                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv2} />}
                    title={
                      <Typography.Text>
                        {"Get relaxed with instant confirmation on bookings"}
                      </Typography.Text>
                    }
                  />
                </List.Item>
              </List>
            </Card> */}
            <CheckoutRightPenalComponent></CheckoutRightPenalComponent>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default AddToCartComponent;
